import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./lib/auth";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import AppLayout from "./components/layout/AppLayout";
import Home from "./pages/Home";
import Debates from "./pages/Debates";
import DebateDetail from "./pages/DebateDetail";
import Thoughts from "./pages/Thoughts";
import Create from "./pages/Create";
import Groups from "./pages/Groups";
import GroupDetail from "./pages/GroupDetail";
import Profile from "./pages/Profile";
import Verify from "./pages/Verify";
import Notifications from "./pages/Notifications";
import Search from "./pages/Search";
import Settings from "./pages/Settings";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminVerifications from "./pages/admin/AdminVerifications";
import AdminContent from "./pages/admin/AdminContent";
import AdminReports from "./pages/admin/AdminReports";
import ChatsShell from "./pages/ChatsShell";
import ChatThread from "./pages/ChatThread";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-muted-foreground label-mono">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/home" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />

          <Route element={<Protected><AppLayout /></Protected>}>
            <Route path="/home" element={<Home />} />
            <Route path="/debates" element={<Debates />} />
            <Route path="/debates/:id" element={<DebateDetail />} />
            <Route path="/thoughts" element={<Thoughts />} />
            <Route path="/create" element={<Create />} />
            <Route path="/groups" element={<Groups />} />
            <Route path="/groups/:id" element={<GroupDetail />} />
            <Route path="/profile/:username" element={<Profile />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/search" element={<Search />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/chats" element={<ChatsShell />}>
              <Route path=":peer_id" element={<ChatThread />} />
            </Route>
          </Route>

          <Route path="/admin" element={<Protected adminOnly><AdminLayout /></Protected>}>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="verifications" element={<AdminVerifications />} />
            <Route path="content" element={<AdminContent />} />
            <Route path="reports" element={<AdminReports />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
